module.exports = __webpack_public_path__ + "static/img/solar-energy-06.bdb2f6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/solar-energy/solar-energy-06.jpg
// module id = aQ58
// module chunks = 98